{
  "welcome": "Bienvenido a AirPlx {{email}}",
  "errorTitle": "No pudimos iniciar tu sesión.",
  "errorMessage": "Haz clic en el botón de abajo para intentar de nuevo. Si el problema persiste, contacta a support@airplx.com."
}
